import React, { ComponentType } from 'react';
import { withContentRect } from 'react-measure';

import { ClassName, cn } from '../../utils';
import styles from './index.module.scss';


interface Dimensions {
    readonly width: number;
    readonly height: number;
}

type AutoSizerProps = ClassName & {
    children: (dimensions: Dimensions) => React.ReactNode;
}

export const AutoSizer: ComponentType<AutoSizerProps> = withContentRect('bounds')(({
    className,
    measureRef,
    contentRect: { bounds: { width, height } },
    children,
}) => (
    <div ref={measureRef} className={cn(styles.autoSizer, className)}>
        <div>
            {width * height > 0 && children({ width, height })}
        </div>
    </div>
));
